var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"tour-container","pa-0":""}},[_c('fdi-restaurant-navigation',{attrs:{"restaurants":_vm.restaurants}}),_c('transition',{attrs:{"name":"fade"}},_vm._l((_vm.steps),function(step,i){return (i==_vm.currentStepIndex)?_c('fdi-step',{key:'step-'+ i+1,attrs:{"step":step}}):_vm._e()}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }